import { $Qll } from "../utils/query-selector";

export const initTopBarSlider = () => {
  let sliderIndex = 0;
  const sliderItems = $Qll('.top-bar-item-js');
  if (!sliderItems.length) return;

  sliderItems[sliderIndex].style.display = 'flex';

  setInterval(() => {
    sliderItems[sliderIndex].style.display = 'none';
    sliderIndex = (sliderIndex + 1) % sliderItems.length;
    sliderItems[sliderIndex].style.display = 'flex';
  }, 7000);
}
